import React, { useState, useEffect, useContext } from "react";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button, Spinner } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { Form, FormControl } from "react-bootstrap";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Import Bootstrap JS
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import Pagination from "../Whatsapp/Pagination"; // Ensure the Pagination component is correctly imported
import MyContext from "../../MyContext";
import { Row, Col } from 'react-bootstrap';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import excel from "../../images/excel (2).svg"
import Placeholder from "../../images/Place Holder 3 1.webp"
import Placeholder1 from "../../images/Place Holder.webp"
import Placeholder2 from "../../images/Place Holder_1.webp"
import loader from "../../images/Anlook.svg"
import refreshicon from "../../images/refresh-2.svg"
import * as XLSX from "xlsx";
import "./AdminDashboard.css";
import NoIndex from "../NoIndex";
const EntryFields = ({
    entriesValue,
    onEntriesChange,
    pageNumber,
    onPageNumberChange
}) => {
    const entriesOptions = [1000, 5000, 10000, 100000];

    return (
        <Row className="align-items-center g-3">
            <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 text-nowrap">No. of entries:</Form.Label>
                    <Form.Select
                        size="sm"
                        value={entriesValue}
                        onChange={onEntriesChange}
                        style={{ width: '100px', height: '35px' }}
                    >
                        {entriesOptions.map(option => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>

            <Col xs="auto">
                <Form.Group className="d-flex align-items-center gap-2">
                    <Form.Label className="mb-0 text-nowrap">Page No:</Form.Label>
                    <Form.Control
                        size="sm"
                        type="number"
                        value={pageNumber}
                        onChange={onPageNumberChange}
                        min={1}
                        style={{ width: '70px', height: '35px' }}
                    />
                </Form.Group>
            </Col>
        </Row>
    );
};
const StatusBadge = ({ status, reason }) => {
    const getStatusStyles = (status) => {
        const baseStyle = {
            padding: "4px 12px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "500",
            display: "inline-block",
            textTransform: "capitalize",
            minWidth: "120px",
            textAlign: "center",
            cursor: "pointer",
        };

        const statusStyles = {
            delivered: {
                backgroundColor: "#E5F6ED",
                color: "#0B7D3E",
                border: "1px solid #A6E5C6",
            },
            failed: {
                backgroundColor: "#FFEBEB",
                color: "#DE350B",
                border: "1px solid #FFBDBD",
            },
            read: {
                backgroundColor: "#EEF6FF",
                color: "#0052CC",
                border: "1px solid #B3D4FF",
            },
            interested: {
                backgroundColor: "#FFF7E6",
                color: "#B76E00",
                border: "1px solid #FFE5B3",
            },
            accepted: {
                backgroundColor: "#E6F7FF",
                color: "#0073B7",
                border: "1px solid #A3DAFF",
            },
            submitted: {
                backgroundColor: "#F6E5E5",
                color: "#7D0B0B",
                border: "1px solid #E5A6A6"
            },
            reply: {
                backgroundColor: "rgb(129, 160, 2 , 0.1)",
                color: "rgb(129, 160, 2)",
                border: "1px solid rgb(129, 160, 2)",
            },
            Completed: {
                backgroundColor: "#E5F6ED",
                color: "#0B7D3E",
                border: "1px solid #A6E5C6",
            },
            Stopped: {
                backgroundColor: "#FFEBEB",
                color: "#DE350B",
                border: "1px solid #FFBDBD",
            },
            Running: {
                backgroundColor: "rgb(129, 160, 2 , 0.1)",
                color: "rgb(129, 160, 2)",
                border: "1px solid rgb(129, 160, 2)",
            },
            Failed: {
                backgroundColor: "#FFEBEB",
                color: "#DE350B",
                border: "1px solid #FFBDBD",
            },
        };

        return {
            ...baseStyle,
            ...statusStyles[status],
        };
    };

    return (
        <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{reason || status?.toUpperCase()}</Tooltip>}
        >
            <span style={getStatusStyles(status)}>{status}</span>
        </OverlayTrigger>
    );
};
const StatusTemplateBadge = ({ templateID, templates }) => {
    // Find the template object that matches templateID
    const template = templates.find((item) => item.name === templateID);

    function extractHeaderAndBody(template) {
        let headerText = "";
        let bodyText = "";

        if (template && template.components && Array.isArray(template.components)) {
            template.components.forEach((component) => {
                if (component.type === "HEADER" && component.text) {
                    headerText = component.text;
                }
                if (component.type === "BODY" && component.text) {
                    bodyText = component.text;
                }
            });
        }

        return { headerText, bodyText };
    }

    const Message = extractHeaderAndBody(template);


    return (
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip>
                    {Message.headerText} {Message.bodyText}
                </Tooltip>
            }
        >
            <span>{templateID}</span>
        </OverlayTrigger>
    );
};

const AdminCampaigns = ({ Admin }) => {
    const { baseUrl, config } = useContext(MyContext);
    const [loading, setLoading] = useState(false);
    const [Campaign, setCampaign] = useState([]);

    const [Logs, setLogs] = useState([])
    const [searchTerm, setSearchTerm] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 200; // Number of items per page
    const [entriesValue, setEntriesValue] = useState(1000);
    const [pageNumber, setPageNumber] = useState(1);
    const [WhatsappNumbers, setWhatsappNumbers] = useState([]);
    const [MultiplePhoneNumber, setMultiplePhoneNumber] = useState(false);
    const [SingleWhatsApp, setSingleWhatsApp] = useState("");
    const [Status, setStatus] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [CampName, setCampName] = useState("")
    const [ModalLoading, setModalLoading] = useState(false)
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [animate, setAnimate] = useState(false);

    const [filterText, setFilterText] = useState("");
    const parsedAdmin = JSON.parse(Admin);



    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getOneWeekBackDate = () => {
        const oneWeekBack = new Date();
        oneWeekBack.setDate(oneWeekBack.getDate() - 3);
        const year = oneWeekBack.getFullYear();
        const month = String(oneWeekBack.getMonth() + 1).padStart(2, '0');
        const day = String(oneWeekBack.getDate()).padStart(2, '0');
        return `${year}-${month}-{day}`;
    };

    // fetching the campaigns using the Anlook api.
    const getLogs = async (status, id, name, userid) => {
        try {
            setModalLoading(true);
            setIsOpen(true);
            setStatus(status);
            setCampName(name);
            setLogs([]);


            var raw = JSON.stringify({
                userid: userid,
                campaignId: id,
                status: status,
            });

            var requestOptions = {
                method: "POST",
                headers: config.headers,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(`${baseUrl}/api/Whatsapp/v1.0/getWhatsappLogs`, requestOptions);
            const data = await res.json();

            if (data?.responseCode == "00") {
                setLogs(data.response);
            }
        } catch (error) {
            console.log({ error });
        } finally {
            setModalLoading(false);
        }
    };

    useEffect(() => {
        setStartDate(getOneWeekBackDate());
        setEndDate(getCurrentDate());

    }, []);

    // useEffect(() => {
    // getLogs();
    // }, [Status])


    const totalPages = Math.ceil(Campaign?.length / itemsPerPage);

    const handlePageClick = (page) => {
        setCurrentPage(page);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };
    const getCampaign = async (adminPkid) => {
        try {
            setLoading(true);
        
    
            const raw = JSON.stringify({
                userid: parsedAdmin.pkid,
            });
    
            const res = await fetch(`${baseUrl}/api/SuperAdmin/v1.0/getAllCampaigns`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    ...config.headers,
                },
                body: raw,
                redirect: "follow",
            });
    
            const data = await res.json();
    
            if (data?.responseCode === "00") {
                setCampaign(data.response);
         
            } else {
                console.warn("API returned error response:", data);
            }
        } catch (error) {
            console.log({ error });
        } finally {
            setLoading(false);
        }
    };
 
    


    useEffect(() => {
        if (WhatsappNumbers && WhatsappNumbers.length === 1) {
            setMultiplePhoneNumber(false);
            WhatsappNumbers.map((Num, i) => setSingleWhatsApp(Num.phone_no_id));
        } else if (WhatsappNumbers && WhatsappNumbers.length !== 1) {
            setMultiplePhoneNumber(true);
            WhatsappNumbers.map((Num, i) => i === 0 ? setSingleWhatsApp(Num.phone_no_id) : "");
        }
    }, [WhatsappNumbers]);

    // Sort Campaign array in descending order by date
    const sortedCampaign = [...Campaign]?.sort((a, b) => new Date(b.indate) - new Date(a.indate));

    const displayedItems = sortedCampaign.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    //Universal filter bar for displayedItems
    const filteredItems = displayedItems.filter((item) => {
        const search = filterText.toLowerCase();

        return (
            item.id?.toString().toLowerCase().includes(search) ||
            item.user_name?.toLowerCase().includes(search) ||
            item.campaign_name?.toLowerCase().includes(search) ||
            item.template_category?.toLowerCase().includes(search) ||
            item.status?.toLowerCase().includes(search)
        );
    });

    const thStyle = {
        backgroundColor: "#007bff",
        color: "white",
        padding: "8px",
        border: "1px solid #ddd",
    };

    const tdStyle = {
        padding: "8px",
        border: "1px solid #ddd",
        textAlign: "center",
    };
    const getVendorAccounts = async (userid, phoneNoId) => {
        try {

            var raw = JSON.stringify({
                userid: "A" + userid,
                phoneNumberId: phoneNoId
            });

            var requestOptions = {
                method: "POST",
                headers: config.headers,
                body: raw,
                redirect: "follow",
            };

            const res = await fetch(
                `${baseUrl}/api/Whatsapp/v1.0/getTemplates`,
                requestOptions,
            );

            const data = await res.json();

            if (data?.responseCode == "00") {
                setTemplates(data?.response.data);
            } else {
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {

        }
    };
    // Handle preview button click
    const handlePreview = (templateId) => {
        setIsLoading(true);
        setShowModal(true);

        // Simulating API call delay

        const template = templates.find((temp) => temp.name === templateId);
      
        setSelectedTemplate(template);
        setIsLoading(false);

    };
    useEffect(() => {
        setAnimate(false);
        setTimeout(() => setAnimate(true), 10);
    }, [templates]);

    const replaceVariablesBody = (text) => {
        const replacements = ["John Doe", "Messaging"]; // Replace with dynamic values
        return text.replace(/{{(\d+)}}/g, (_, index) => replacements[index - 1] || "");
    };
    const downloadExcel = () => {
        if (Logs.length === 0) return;

        // Define the header
        const headers = [
            ["ID", "Contact", "Business Acc. Id", "Phone No. Id", "Status", "Date", "Product", "Category", "Contact Name", "Message Category", "Error Code", "Error Description"],
        ];

        // Map logs data into an array format
        const logsData = Logs.map((item) => [
            item.id,
            item.contact,
            item.business_acc_id,
            item.phone_no_id,
            item.status,
            item.indate,
            item.product,
            item.category,
            item.contact_name || "N/A",
            item.message_category,
            item.error_code || "N/A",
            item.error || "N/A",
        ]);

        // Combine headers with data
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...logsData]);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Logs Report");

        // Generate and trigger download
        XLSX.writeFile(workbook, `Whatsapp_Logs_${CampName}_${Status}.xlsx`);
    };
    function refresh() {
        getCampaign();
    }
    useEffect(() => {
        getCampaign();
    }, [])
    
    return (
        <div className="marginRight">
            <div className="d-flex justify-content-center text-center ">
                <ToastContainer />  <NoIndex />
            </div>
            <div>
                {/* Modal for template preview */}
                <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Message Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {isLoading ? (
                            <div className="text-center">
                                <Spinner animation="border" />
                                <p>Generating preview...</p>
                            </div>
                        ) : selectedTemplate ? (
                            <div>

                                <div className=" p-5 bg-light">


                                    <div className={`message-bubble border ${animate ? "message-bubble-animate " : ""}`}>
                                        {/* HEADER */}
                                        <div className="d-flex justify-content-center">{selectedTemplate.components?.find(c => c.format === "IMAGE") ? <img src={Placeholder} alt="" style={{ width: "14rem" }} /> : ""}
                                            {selectedTemplate.components?.find(c => c.format === "VIDEO") ? <img src={Placeholder1} alt="" style={{ width: "14rem" }} /> : ""}{selectedTemplate.components?.find(c => c.format === "DOCUMENT") ? <img src={Placeholder2} alt="" style={{ width: "14rem" }} /> : ""}</div>
                                        <div className="header-text">
                                            {selectedTemplate.components?.find(c => c.type === "HEADER")?.text || ""}
                                        </div>

                                        {/* BODY */}
                                        <div className="body-text py-1">
                                            <div>
                                                {replaceVariablesBody(selectedTemplate.components?.find(c => c.type === "BODY")?.text || "")}
                                            </div>
                                        </div>

                                        {/* FOOTER */}
                                        <div className="footer-text">
                                            {selectedTemplate.components?.find(c => c.type === "FOOTER")?.text || ""}
                                        </div>

                                        <div className="footer-text text-end">05:27 PM</div>
                                    </div>

                                    {/* BUTTONS */}
                                    {selectedTemplate.components
                                        ?.find(c => c.type === "BUTTONS")?.buttons?.map((button, index) => (
                                            <div key={index} className={`button-bubble ${animate ? "button-bubble-animate border mt-2" : ""}`}>
                                                <div className="button-text text-success text-center mb-1">
                                                    {button.text}
                                                </div>
                                            </div>
                                        ))}
                                </div>

                            </div>
                        ) : (
                            <p>No template found.</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
                <div
                    className="p-4 bg-white"
                    style={{
                        height: "100vh",
                        fontFamily: "Nunito,sans-serif",
                    }}
                >
                    <div className="px-4 justify-content-center">
                        <div className="isancharr-campaign-container mb-4 admin-green-gradient admin-popup">
                            {/* Header Section */}
                            <div className="isancharr-header d-flex justify-content-between">
                                <h2 className=""> WhatsApp Message Logs</h2>
                                <div className="d-flex">

                                    {/* Action Buttons */}
                                    <div className="isancharr-actions">

                                        <button className="isancharr-refresh-btn" title='Refresh' onClick={() => refresh()}>
                                            <img src={refreshicon} alt="Refresh" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            {/* Top Controls - Search & WhatsApp Number */}
                            <div className="isancharr-controls d-flex justify-content-start">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    className="form-control mb-3 w-50"
                                    value={filterText}
                                    onChange={(e) => setFilterText(e.target.value)}
                                />



                            </div>


                        </div>


                        {loading ? (
                            <div className=" m-5 p-5 d-flex justify-content-center">
                                <div className=" d-flex flex-column align-items-center justify-content-center ">
                                    <div className="p-3">
                                        <div className="loader"> </div>
                                    </div>
                                    <div className="p-3">
                                        <img src={loader} alt="" height={40} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <><div className="scrollable-table">
                                <table className="table table-bordered table-hover">
                                    <thead style={{ borderRadius: "10px" }}>
                                        <tr
                                            className="text-center greenColour py-4"
                                            style={{
                                                borderBottom: "1px solid #ccc",
                                            }}
                                        >
                                            <th
                                                className="p-3 th-style"

                                            >
                                                S.No.
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                ID
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                User Name
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Campaign Name
                                            </th>
                                            <th
                                                className="pb-3 th-style"

                                            >
                                                {" "}
                                                Start Time
                                            </th>
                                            <th
                                                className="pb-3 th-style"

                                            >
                                                End Time
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Template
                                            </th>

                                            <th
                                                className="p-3 th-style"

                                            >
                                                Category
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Sent
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Delivered
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Accepted
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Read
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Failed
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Responded
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Preview
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Audience
                                            </th>
                                            <th
                                                className="p-3 th-style"

                                            >
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredItems.map((item, index) => (
                                            <tr
                                                key={index}
                                                style={{
                                                    borderBottom: "1px solid #DDD",
                                                    padding: "0px 0px",
                                                }}
                                            >

                                                <td className=" text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                                <td className="text-center">{item.id}</td>
                                                <td className="text-center">{item.user_name}</td>
                                                <td className="text-center">{item.campaign_name?.toUpperCase()}</td>
                                                <td className="text-center">{item.campaign_start}</td>
                                                <td className="text-center">{item.campaign_end}</td>
                                                <td className="text-center cursor-pointer"> <StatusTemplateBadge templateID={item.template_id} templates={templates} /></td>
                                                <td className="text-center"><b>{item.template_category}</b></td>
                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("sent", item.id, item.campaign_name, item.userid)}><b>{item.sent || 0}</b></td>

                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("delivered", item.id, item.campaign_name, item.userid)}><b>{item.delivered || 0}</b></td>
                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("accepted", item.id, item.campaign_name, item.userid)}><b>{item.accepted || 0}</b></td>
                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("read", item.id, item.campaign_name, item.userid)}><b>{item.read || 0}</b></td>
                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("failed", item.id, item.campaign_name, item.userid)}><b>{item.failed || 0}</b></td>
                                                <td className="text-center cursor-pointer clickable-text" onClick={() => getLogs("responded", item.id, item.campaign_name, item.userid)}><b>{item.responded || 0}</b></td>

                                                <td className="text-center cursor-pointer">

                                                    <button
                                                        onClick={() => {
                                                            handlePreview(item.template_id);
                                                            getVendorAccounts(item.userid, item.phone_no_id)
                                                        }}
                                                        className="btn text-primary bg-light">Preview</button>

                                                </td>
                                                <td className="pt-4 text-center">
                                                    <a href={item.excel_url} download target="_blank" rel="noopener noreferrer" className="cursur-pointer ">
                                                        <img src={excel} alt="" height={30} />
                                                    </a>
                                                </td>
                                                <td className="text-center cursor-pointer">

                                                    <StatusBadge status={item.status} reason={item.error} />


                                                </td>

                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                                <div className="pb-4">
                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        onNextPage={handleNextPage}
                                        onPrevPage={handlePrevPage}
                                        onPageClick={handlePageClick}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div>


                {isOpen && (
                    <div
                        style={{
                            position: "fixed",
                            top: "0",
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",

                        }}
                        className="justify-content-center align-items-center d-flex"
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: "1rem",
                                borderRadius: "8px",
                                width: "75vw",
                                marginRight: '12vw',
                                maxHeight: "85%",
                                overflowY: "auto",

                            }}
                            className='d-flex flex-column'
                        >
                            <h2 style={{ textAlign: "center", marginBottom: "10px" }}>
                                {CampName} - {Status?.toUpperCase()}
                            </h2>

                            {/* Download Excel Button - Only Visible When Logs Have Data */}
                            {Logs.length > 0 && (
                                <button
                                    onClick={downloadExcel}
                                    style={{
                                        marginBottom: "10px",
                                        padding: "8px 16px",
                                        backgroundColor: "#28a745",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer",
                                        display: "block",
                                        marginLeft: "auto",
                                    }}
                                >
                                    Download Excel Report
                                </button>
                            )}
                            <div className="d-flex overflow-scroll">
                                <table
                                    style={{
                                        width: "100%",
                                        borderCollapse: "collapse",
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th style={thStyle}>ID</th>
                                            <th style={thStyle}>Contact</th>
                                            <th style={thStyle}>Business Acc Id</th>
                                            <th style={thStyle}>Phone No Id</th>
                                            <th style={thStyle}>Status</th>
                                            <th style={thStyle}>Date</th>
                                            <th style={thStyle}>Product</th>
                                            <th style={thStyle}>Category</th>
                                            <th style={thStyle}>Contact Name</th>
                                            <th style={thStyle}>Message Category</th>
                                            <th style={thStyle}>Error code</th>
                                            <th style={thStyle}>Error Description</th>
                                        </tr>
                                    </thead>
                                    {ModalLoading ? (
                                        <div className="d-flex justify-content-center"></div>
                                    ) : (
                                        <tbody>
                                            {Logs.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={tdStyle}>{item.id}</td>
                                                    <td style={tdStyle}>{item.contact}</td>
                                                    <td style={tdStyle}>{item.business_acc_id}</td>
                                                    <td style={tdStyle}>{item.phone_no_id}</td>
                                                    <td style={tdStyle}>{item.status}</td>
                                                    <td style={tdStyle}>{item.indate}</td>
                                                    <td style={tdStyle}>{item.product}</td>
                                                    <td style={tdStyle}>{item.category}</td>
                                                    <td style={tdStyle}>{item.contact_name || "N/A"}</td>
                                                    <td style={tdStyle}>{item.message_category}</td>
                                                    <td style={tdStyle}>{item.error_code || "N/A"}</td>
                                                    <td style={tdStyle}>{item.error || "N/A"}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    )}
                                </table>
                            </div>


                            <button
                                onClick={() => {
                                    setIsOpen(false);
                                    setLogs([]);
                                }}
                                style={{
                                    marginTop: "10px",
                                    padding: "8px 16px",
                                    backgroundColor: "#dc3545",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    display: "block",
                                    marginLeft: "auto",
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

};

export default AdminCampaigns;